import { CountryFilterState } from './country.types';

// 0 = All option
export const getDefaultCountryFilter = (): CountryFilterState => ({
  country: null,
});
export const defaultCountryFilter = getDefaultCountryFilter();
